/**
 * How long a download's object URL outlives the click. Some browsers start
 * reading the blob after the click returns and drop the download if the URL
 * is already revoked; FileSaver.js waits 40 seconds for the same reason.
 */
export const REVOKE_AFTER_MS = 40_000

/** Trigger a file download from a blob in the browser. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = window.document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS)
}
